<template>
  <div>
    <el-form ref="productPropertyForm" :model="formData" label-width="200px" :disabled="disabled">
      <el-row>
        <el-col v-if="hasDataType1005">
          <!-- 井道信息添加按钮 -->
          <div class="hoistway-info-section">
            <el-form-item label="井道信息">
              <el-button type="primary" @click="openHoistwayModal">添加</el-button>
            </el-form-item>
          </div>
        </el-col>
        <el-col v-for="(item, index) in visibleProperties" :key="item._originalIndex || index" :span="8">
          <el-form-item v-if="item.visible" :label="item.propertyName" :prop="'materialPropertyVOES.' + (item._originalIndex || index) + '.propertyValue'" :rules="{ required: item.mustInput, message: '请输入', trigger: 'change' }">
            <div class="form-item-container">
              <template v-if="String(item.dataType) === '1000'">
                <el-input v-model="item.propertyValue" :disabled="!configureReadOnly ? item.readOnly : false" @change="handleChange"/>
              </template>
              <template v-else-if="String(item.dataType) === '1001'">
                <el-input-number
                    v-model="item.propertyValue"
                    :precision="0"
                    :min="0"
                    :disabled="!configureReadOnly ? item.readOnly : false"
                    @change="handleChange"/>
              </template>
              <template v-else-if="String(item.dataType) === '1002'">
                <el-input-number
                    v-model="item.propertyValue"
                    :precision="2"
                    :min="0"
                    :disabled="!configureReadOnly ? item.readOnly : false"
                    @change="handleChange"/>
              </template>
              <template v-else-if="['1004'].includes(String(item.dataType))">
                <el-select
                    v-model="item.propertyValue"
                    filterable
                    :multiple="Number(item.valueType) === 1"
                    :disabled="!configureReadOnly ? item.readOnly : false"
                    @change="handleChangeSelect">
                  <el-option
                      v-for="value in item.propertyDetails"
                      :key="value.propertyValue"
                      :label="value.displayValue"
                      :value="value.propertyValue"/>
                </el-select>
              </template>
              <template v-else-if="String(item.dataType) === '1006'">
                <el-radio-group v-model="item.propertyValue" :disabled="!configureReadOnly ? item.readOnly : false" @change="handleChange">
                  <el-radio label="是" value="是"/>
                  <el-radio label="否" value="否"/>
                </el-radio-group>
              </template>
              <el-checkbox v-if="configureReadOnly" v-model="item.readOnly" class="readonly-checkbox">锁定</el-checkbox>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 井道信息弹窗 -->
    <el-dialog
        title="井道信息：（各停层站分布及停层布置）"
        :visible.sync="showHoistwayModal"
        width="600px"
        :close-on-click-modal="false"
        append-to-body
        :modal-append-to-body="true">
      <el-form :model="hoistwayForm" label-width="120px">
        <el-table
            :data="hoistwayRows"
            border
            :show-header="true">
          <el-table-column label="实际层数" width="100" align="center">
            <template slot-scope="scope">
              {{scope.row.layerNum}}
            </template>
          </el-table-column>
          <el-table-column label="楼间距（M）" width="120">
            <template slot-scope="scope">
              <el-input 
                  v-model="scope.row.floorSpacing" 
                  :disabled="scope.row.isLastRow" 
                  placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column label="楼层按钮字符" width="150">
            <template slot-scope="scope">
              <el-select
                  v-if="frontStopsOptions.length"
                  v-model="scope.row.frontStops"
                  filterable
                  clearable
                  placeholder="请选择">
                <el-option
                    v-for="option in frontStopsOptions"
                    :key="option.propertyValue"
                    :label="option.displayValue"
                    :value="option.propertyValue"/>
              </el-select>
              <el-input v-else v-model="scope.row.frontStops" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column label="后门停站数" width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.backStops" placeholder="请输入"/>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showHoistwayModal = false">取消</el-button>
        <el-button type="primary" @click="saveHoistwayInfo">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      productList: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      configureReadOnly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        formData: {
          materialPropertyVOES: [],
        },
        showHoistwayModal: false,
        hoistwayRows: [],
        hoistwayForm: {},
      };
    },
    computed: {
      // 过滤掉 dataType === 1005 的属性
      visibleProperties() {
        return this.formData.materialPropertyVOES.filter(item => String(item.dataType) !== "1005");
      },
      // 判断是否包含 dataType === 1005 的属性
      hasDataType1005() {
        return this.formData.materialPropertyVOES.some(item => String(item.dataType) === "1005");
      },
      // 获取层数（OuterNo === 'QTY_FLR_NUMBERS_STEP' 的值）
      layerCount() {
        const items = this.formData.materialPropertyVOES || [];
        const item = items.find(item => 
          item.outerNO === "QTY_FLR_NUMBERS_STEP" || item.outerNo === "QTY_FLR_NUMBERS_STEP"
        );
        return item ? parseInt(item.propertyValue) || 0 : 0;
      },
      // 楼层按钮字符的下拉选项：取按钮字符属性上携带的 propertyDetails
      frontStopsOptions() {
        const items = this.formData.materialPropertyVOES || [];
        const item = items.find(i => ["TYP_COP_BUTTON_CHAR_STEP", "KZCOP008", "QTY_FLR_STOPS_F_STEP"].includes(i.outerNO || i.outerNo));
        return (item && item.propertyDetails) || [];
      },
    },
    watch: {
      // productList 由父组件在接口重算后整体替换。
      // 内部渲染数据以 productList 为唯一数据源做兜底同步，
      // 避免父组件漏调 freshFormData 时下拉选项/字段显隐停留在旧接口数据上导致错位
      productList: {
        handler(newList, oldList) {
          if (newList === oldList) {
            return;
          }
          // 内容未变化（仅引用变化）时跳过，避免打断用户在表单中的操作
          if (JSON.stringify(newList || []) === JSON.stringify(oldList || [])) {
            return;
          }
          this.refreshFormData(newList);
        },
        deep: true,
      },
    },
    mounted() {
      this.initFormData();
    },
    methods: {
      initFormData() {
        this.refreshFormData(this.productList);
      },
      freshFormData(productList) {
        this.refreshFormData(productList);
      },
      // 将外部列表同步到内部 formData（多选属性值拆为数组，并记录原始下标）
      refreshFormData(productList) {
        this.formData.materialPropertyVOES = (productList || []).map((item, index) => {
          // 处理多选下拉框：将逗号分隔的字符串转为数组
          if (Number(item.valueType) === 1 && typeof item.propertyValue === "string") {
            const { propertyValue, ...rest } = item;
            return {
              ...rest,
              propertyValue: propertyValue ? propertyValue.split(",") : [],
              _originalIndex: index,
            };
          }
          return {
            ...item,
            _originalIndex: index,
          };
        });
      },
      getRef() {
        return this.$refs.productPropertyForm;
      },
      resetFields() {
        this.$refs.productPropertyForm.resetFields();
      },
      updateProductForm() {
        const processedData = this.formData.materialPropertyVOES.map(item => {
          if (Number(item.valueType) === 1 && Array.isArray(item.propertyValue)) {
            const {propertyValue, ...rest} = item;
            return {
              ...rest,
              propertyValue: propertyValue.join(","),
            };
          }
          return item;
        });
        this.$emit("UpdateProductForm", processedData);
      },
      handleChange() {
        this.$emit("change");
      },
      handleChangeSelect() {
        this.$emit("change");
        this.$emit("selectChange");
      },
      // 打开井道信息弹窗
      openHoistwayModal() {
        this.initHoistwayRows();
        this.showHoistwayModal = true;
      },
      // 初始化井道信息行（从已有属性值反向获取数据）
      initHoistwayRows() {
        const count = this.layerCount || 1;
        const getPropertyValue = (items, outerNOs) => {
          if (typeof outerNOs === "string") {
            outerNOs = [outerNOs];
          }
          const item = items.find(i => outerNOs.includes(i.outerNO) || outerNOs.includes(i.outerNo));
          if (!item) return "";
          const value = item.propertyValue;
          if (Array.isArray(value)) {
            return value.join(",");
          }
          return String(value || "");
        };

        const floorSpacingStr = getPropertyValue(this.formData.materialPropertyVOES, "DIM_FLR_SPACING_STEP");
        const frontStopsStr = getPropertyValue(this.formData.materialPropertyVOES, ["TYP_COP_BUTTON_CHAR_STEP", "KZCOP008", "QTY_FLR_STOPS_F_STEP"]);
        const backStopsStr = getPropertyValue(this.formData.materialPropertyVOES, "QTY_FLR_STOPS_R_STEP");

        const floorSpacingArr = floorSpacingStr ? floorSpacingStr.split(",") : [];
        const frontStopsArr = frontStopsStr ? frontStopsStr.split(",") : [];
        const backStopsArr = backStopsStr ? backStopsStr.split(",") : [];
       
        // 如果楼层数不变且已有数据，保留上一次输入的值
        if (this.hoistwayRows.length === count && count > 0 && !floorSpacingStr && !frontStopsStr && !backStopsStr) {
          return; // 保留原有数据，不重新初始化
        }
        
        // 重新初始化，填入从属性读取的值
        this.hoistwayRows = [];
        for (let i = 1; i <= count; i++) {
          this.hoistwayRows.push({
            layerNum: i,
            floorSpacing: floorSpacingArr[i - 1] || "", // 楼间距少一行（顶楼没有）
            frontStops: frontStopsArr[i - 1] || "",
            backStops: backStopsArr[i - 1] || "",
            isLastRow: i === count,
          });
        }
      },
      // 保存井道信息
      saveHoistwayInfo() {
        // 获取楼间距数组（排除最后一行，因为顶楼没有楼间距）并转为逗号分隔字符串
        const floorSpacingArr = this.hoistwayRows.slice(0, -1).map(row => row.floorSpacing);
        const floorSpacingStr = floorSpacingArr.join(",");

        // 获取前门停站数数组并转为逗号分隔字符串
        const frontStopsArr = this.hoistwayRows.map(row => row.frontStops);
        const frontStopsStr = frontStopsArr.join(",");

        // 获取后门停站数数组并转为逗号分隔字符串
        const backStopsArr = this.hoistwayRows.map(row => row.backStops);
        const backStopsStr = backStopsArr.join(",");

        // 找到对应的属性并赋值
        this.formData.materialPropertyVOES.forEach(item => {
          const outerNoValue = item.outerNO || item.outerNo;
          if (outerNoValue === "DIM_FLR_SPACING_STEP") {
            item.propertyValue = floorSpacingStr;
          } else if ([ "QTY_FLR_STOPS_F_STEP"].includes(outerNoValue)) {
            item.propertyValue = frontStopsStr;
          } else if (["TYP_COP_BUTTON_CHAR_STEP", "KZCOP008"].includes(outerNoValue)) {
            const optionsLists = item.propertyDetails || [];
            const validValues = new Set(optionsLists.map(option => option.propertyValue));
            item.propertyValue = frontStopsArr.filter(value => value !== "" && validValues.has(value));
          } else if (outerNoValue === "QTY_FLR_STOPS_R_STEP") {
            item.propertyValue = backStopsStr;
          } else if (outerNoValue === "DIM_TH_ DOUBLE_DOOR_STEP") {
            // 最高双开门提升高度[M]= 后门停站数不为空那行的楼间距之和
            const totalHeight = this.hoistwayRows
              .filter(row => row.backStops !== "" && row.backStops !== null && row.backStops !== undefined)
              .reduce((sum, row) => sum + (parseFloat(row.floorSpacing) || 0), 0);
            item.propertyValue = Number(totalHeight.toFixed(2));
          } else if(outerNoValue === "DIM_TH_STEP") {
            const totalHeight = this.hoistwayRows.reduce((sum, row) => sum + (parseFloat(row.floorSpacing) || 0), 0);
            item.propertyValue = Number(totalHeight.toFixed(2));
          } else if(outerNoValue === "QTY_FLR_DOOR_STEP") {
            // 门数：贯通门=有，前门数+后门数；否则 前门数
            const frontDoorCount = frontStopsArr.filter(value => value !== "").length;
            const backDoorCount = backStopsArr.filter(value => value !== "").length;
            const throughDoorItem = this.formData.materialPropertyVOES.find(i => {
              const o = i.outerNO || i.outerNo;
              return o === "WITH_OPEN_THROUGH_STEP";
            });
            // 贯通门为下拉项，propertyValue 存的是选项值，需通过 propertyDetails 匹配出对应显示文案再判断是否为「有」
            const rawThroughValue = throughDoorItem ? throughDoorItem.propertyValue : "";
            const throughDoorValues = Array.isArray(rawThroughValue)
              ? rawThroughValue
              : String(rawThroughValue || "").split(",").filter(value => value !== "");
            const throughDoorDetails = (throughDoorItem && throughDoorItem.propertyDetails) || [];
            const isThroughDoor = throughDoorValues.some(value => {
              const detail = throughDoorDetails.find(d => String(d.propertyValue) === String(value));
              return detail && detail.displayValue === "有";
            });
            item.propertyValue = isThroughDoor
              ? frontDoorCount + backDoorCount
              : frontDoorCount;
          }

          const propertyName = item.propertyName;
          if (propertyName === "前门数") {
            item.propertyValue = frontStopsArr.filter(value => value !== "").length;
          } else if(propertyName === "后门数") {
            item.propertyValue = backStopsArr.filter(value => value !== "").length;
          }
        });

        this.showHoistwayModal = false;
        this.$message.success("保存成功");
        this.$emit("change");
      },
    },
  };
</script>

<style scoped lang="scss">
::v-deep .el-form-item--mini .el-form-item__content{
  line-height: 27px;
}
.form-item-container {
  display: flex;
  align-items: center;
  .readonly-checkbox{
    margin-left: 10px;
    ::v-deep .el-checkbox__label{
      padding-left: 5px;
    }
  }
}
.hoistway-info-section {
  margin-top: 20px;
}
</style>